import { HttpError } from 'react-admin';

import { errorCodes } from '../../constants/errorMessages';
import errorNotification from '../../utilities/errorNotification';

// The api answers 409 for an Account with no credentials login method, which is an SSO-only
// Account: there is no password login for the requirement to apply to.
export const isSsoOnlyAccount = (error: unknown): boolean => error instanceof HttpError
  && error.status === 409
  && error.message === errorCodes.CREDENTIALS_LOGIN_NOT_CONFIGURED;

const accountSecurityErrorMessage = (error: unknown, defaultMessage: string): string => {
  if (error instanceof HttpError && error.status === 403) {
    return 'You do not have permission to change the account security settings';
  }
  if (error instanceof HttpError && error.message === errorCodes.MFA_NOT_ENABLED) {
    return 'Set up multi-factor authentication for yourself on the Security page before turning off the requirement';
  }

  return errorNotification(error, defaultMessage);
};

export default accountSecurityErrorMessage;
